import { Skeleton } from 'antd';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import styles from './AreaChart.module.css';

const COLORS_LIGHT = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D'];
const COLORS_DARK = ['#3f51b5', '#4caf50', '#f44336', '#ff9800', '#9c27b0', '#607d8b'];

export const CustomAreaChart = ({ data, title, darkMode = false, categories }) => {
  const colors = darkMode ? COLORS_DARK : COLORS_LIGHT;

  return (
    <div className={styles.chartWrapper}>
      <h3 className={styles.heading}>{title}</h3>

      <ResponsiveContainer width='100%' height='90%'>
        {data ? (
          <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray='3 3' stroke={'var(--grid-color)'} />
            <XAxis dataKey='name' stroke={'var(--primary)'} />
            <YAxis stroke={'var(--primary)'} />
            <Tooltip
              contentStyle={{
                backgroundColor: darkMode ? '#2d2d2d' : '#ffffff',
                borderColor: darkMode ? '#444444' : '#e0e0e0',
                color: 'var(--primary)',
              }}
            />

            {categories.map((category, index) => (
              <Area
                key={category}
                type='monotone'
                dataKey={category}
                stackId='1'
                stroke={colors[index % colors.length]}
                strokeWidth={2}
                fillOpacity={0.4}
                fill={colors[index % colors.length]}
              />
            ))}
          </AreaChart>
        ) : (
          <div className={styles.skeletonWrapper}>
            <Skeleton.Node active style={{ width: '100%', height: '100%' }}>
              <></>
            </Skeleton.Node>
          </div>
        )}
      </ResponsiveContainer>
    </div>
  );
};
